import Loading from './Loading';

export default Loading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-loading/es/index.js
// module id = 95
// module chunks = 0